<div class="confirm-dialog">
  <h4 mat-dialog-title>{{ 'common_confirmation' | translate }}</h4>

  <div mat-dialog-content>
    <p>{{ data.message }}</p>
  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()" [color]="data.cancelColor">
      {{ data.cancelText }}
    </button>
    <button mat-button (click)="onConfirm()" [color]="data.confirmColor">
      {{ data.confirmText }}
    </button>
  </div>
</div>
